module.exports = __webpack_public_path__ + "static/img/right-home-row-1.05bb0be4.webp";